<template>
    <div class="col-xl-3 col-lg-4 col-sm-12 col-12 theiaStickySidebar">
      <div class="stickysidebar">
        <form action="#" autocomplete="off" class="sidebar-form">
          <!-- العنوان -->
          <div class="sidebar-heading">
            <h3>ماذا تبحث؟</h3>
          </div>

          <!-- البحث -->
          <div class="product-search">
            <div class="form-custom">
              <input type="text" class="form-control" placeholder="ابحث هنا..." />
              <span><img src="@/assets/img/icons/search.svg" alt="بحث" /></span>
            </div>
          </div>

          <!-- التوافر -->
          <div class="product-availability">
            <h6>التوافر</h6>
            <div class="status-toggle">
              <input id="available" class="check" type="checkbox" v-model="isAvailable" />
              <label for="available" class="checktoggle">مُتاح</label>
            </div>
          </div>

          <!-- الأكوردين -->
          <div class="accord-list">

            <!-- الحالة -->
            <div class="accordion" id="accordionStatus">
              <div class="card-header-new">
                <h6 class="filter-title">
                  <a class="w-100 collapsed" data-bs-toggle="collapse" data-bs-target="#collapseStatus">
                    الحالة
                    <span class="float-end"><i class="fa-solid fa-chevron-down"></i></span>
                  </a>
                </h6>
              </div>
              <div id="collapseStatus" class="collapse">
                <div class="card-body-chat">
                  <div class="selectBox-cont">
                    <label v-for="(value, key) in carStatus" :key="key" class="custom_check w-100">
                      <input type="checkbox" v-model="selectedStatus" :value="value" />
                      <span class="checkmark"></span> {{ key }}
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <!-- نوع السيارة (select بسبب كثرة الخيارات) -->
            <div class="accordion" id="accordionBrand">
              <div class="card-header-new">
                <h6 class="filter-title">
                  <a class="w-100 collapsed" data-bs-toggle="collapse" data-bs-target="#collapseBrand">
                    نوع السيارة
                    <span class="float-end"><i class="fa-solid fa-chevron-down"></i></span>
                  </a>
                </h6>
              </div>
              <div id="collapseBrand" class="collapse">
                <div class="card-body-chat">
                  <select class="form-select" v-model="selectedBrand">
                    <option value="">اختر نوع السيارة</option>
                    <option v-for="brand in carBrands" :key="brand" :value="brand">{{ brand }}</option>
                  </select>
                </div>
              </div>
            </div>
            <!-- السعر -->
            <div class="accordion" id="accordionPrice">
              <div class="card-header-new">
                <h6 class="filter-title">
                  <a class="w-100 collapsed" data-bs-toggle="collapse" data-bs-target="#collapsePrice">
                    السعر
                    <span class="float-end"><i class="fa-solid fa-chevron-down"></i></span>
                  </a>
                </h6>
              </div>
              <div id="collapsePrice" class="collapse">
                <div class="card-body-chat">
                  <div class="row g-2">
                    <div class="col-6">
                      <input
                        type="number"
                        class="form-control"
                        placeholder="من"
                        v-model.number="priceFrom"
                      />
                    </div>
                    <div class="col-6">
                      <input
                        type="number"
                        class="form-control"
                        placeholder="إلى"
                        v-model.number="priceTo"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
             <!-- سنة الصنع (من – إلى) -->
            <div class="accordion" id="accordionYear">
              <div class="card-header-new">
                <h6 class="filter-title">
                  <a class="w-100 collapsed" data-bs-toggle="collapse" data-bs-target="#collapseYear">
                    سنة الصنع
                    <span class="float-end"><i class="fa-solid fa-chevron-down"></i></span>
                  </a>
                </h6>
              </div>
              <div id="collapseYear" class="collapse">
                <div class="card-body-chat">
                  <div class="row g-2">
                    <div class="col-6">
                      <select class="form-select" v-model="yearFrom">
                        <option value="">من</option>
                        <option v-for="year in carYears" :key="year" :value="year">{{ year }}</option>
                      </select>
                    </div>
                    <div class="col-6">
                      <select class="form-select" v-model="yearTo">
                        <option value="">إلى</option>
                        <option v-for="year in carYears" :key="year" :value="year">{{ year }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <!-- بلد التصنيع -->
            <div class="accordion" id="accordionCountry">
              <div class="card-header-new">
                <h6 class="filter-title">
                  <a class="w-100 collapsed" data-bs-toggle="collapse" data-bs-target="#collapseCountry">
                    بلد التصنيع
                    <span class="float-end"><i class="fa-solid fa-chevron-down"></i></span>
                  </a>
                </h6>
              </div>
              <div id="collapseCountry" class="collapse">
                <div class="card-body-chat">
                  <select class="form-select" v-model="selectedCountry">
                    <option value="">اختر البلد</option>
                    <option v-for="country in carCountries" :key="country" :value="country">{{ country }}</option>
                  </select>
                </div>
              </div>
            </div>

            <!-- الوقود -->
            <div class="accordion" id="accordionFuel">
              <div class="card-header-new">
                <h6 class="filter-title">
                  <a class="w-100 collapsed" data-bs-toggle="collapse" data-bs-target="#collapseFuel">
                    الوقود
                    <span class="float-end"><i class="fa-solid fa-chevron-down"></i></span>
                  </a>
                </h6>
              </div>
              <div id="collapseFuel" class="collapse">
                <div class="card-body-chat">
                  <div class="fuel-list">
                    <ul>
                      <li v-for="fuel in fuelTypes" :key="fuel">
                        <div class="input-selection">
                          <input type="radio" v-model="selectedFuel" :id="fuel" :value="fuel" />
                          <label :for="fuel">{{ fuel }}</label>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <!-- الجير -->
            <div class="accordion" id="accordionGear">
              <div class="card-header-new">
                <h6 class="filter-title">
                  <a class="w-100 collapsed" data-bs-toggle="collapse" data-bs-target="#collapseGear">
                    ناقل الحركة
                    <span class="float-end"><i class="fa-solid fa-chevron-down"></i></span>
                  </a>
                </h6>
              </div>
              <div id="collapseGear" class="collapse">
                <div class="card-body-chat">
                  <div class="fuel-list">
                    <ul>
                      <li v-for="gear in gearOptions" :key="gear">
                        <div class="input-selection">
                          <input type="radio" v-model="selectedGear" :id="gear" :value="gear" />
                          <label :for="gear">{{ gear }}</label>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <!-- المحرك -->
            <div class="accordion" id="accordionEngine">
              <div class="card-header-new">
                <h6 class="filter-title">
                  <a class="w-100 collapsed" data-bs-toggle="collapse" data-bs-target="#collapseEngine">
                    سعة المحرك
                    <span class="float-end"><i class="fa-solid fa-chevron-down"></i></span>
                  </a>
                </h6>
              </div>
              <div id="collapseEngine" class="collapse">
                <div class="card-body-chat">
                  <div class="selectBox-cont">
                    <label v-for="(eng, i) in engineOptions" :key="i" class="custom_check w-100">
                      <input type="checkbox" v-model="selectedEngines" :value="eng" />
                      <span class="checkmark"></span> {{ eng }}
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <!-- لون السيارة (select) -->
            <div class="accordion" id="accordionColor">
              <div class="card-header-new">
                <h6 class="filter-title">
                  <a class="w-100 collapsed" data-bs-toggle="collapse" data-bs-target="#collapseColor">
                    لون السيارة
                    <span class="float-end"><i class="fa-solid fa-chevron-down"></i></span>
                  </a>
                </h6>
              </div>
              <div id="collapseColor" class="collapse">
                <div class="card-body-chat">
                  <select class="form-select" v-model="selectedColor">
                    <option value="">اختر اللون</option>
                    <option v-for="color in carColors" :key="color" :value="color">{{ color }}</option>
                  </select>
                </div>
              </div>
            </div>

            <!-- فئة السيارة -->
            <div class="accordion" id="accordionCategory">
              <div class="card-header-new">
                <h6 class="filter-title">
                  <a class="w-100 collapsed" data-bs-toggle="collapse" data-bs-target="#collapseCategory">
                    فئة السيارة
                    <span class="float-end"><i class="fa-solid fa-chevron-down"></i></span>
                  </a>
                </h6>
              </div>
              <div id="collapseCategory" class="collapse">
                <div class="card-body-chat">
                  <div class="selectBox-cont">
                    <label v-for="cat in carCategories" :key="cat" class="custom_check w-100">
                      <input type="checkbox" v-model="selectedCategories" :value="cat" />
                      <span class="checkmark"></span> {{ cat }}
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <!-- قديش ماشية -->
            <div class="accordion" id="accordionMileage">
              <div class="card-header-new">
                <h6 class="filter-title">
                  <a class="w-100 collapsed" data-bs-toggle="collapse" data-bs-target="#collapseMileage">
                    قديش ماشية
                    <span class="float-end"><i class="fa-solid fa-chevron-down"></i></span>
                  </a>
                </h6>
              </div>
              <div id="collapseMileage" class="collapse">
                <div class="card-body-chat">
                  <div class="fuel-list">
                    <ul>
                      <li v-for="m in mileageOptions" :key="m">
                        <div class="input-selection">
                          <input type="radio" v-model="selectedMileage" :id="m" :value="m" />
                          <label :for="m">{{ m }}</label>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
             <!-- المواصفات -->
            <div class="accordion" id="accordionSpecs">
              <div class="card-header-new">
                <h6 class="filter-title">
                  <a class="w-100 collapsed" data-bs-toggle="collapse" data-bs-target="#collapseSpecs">
                    المواصفات
                    <span class="float-end"><i class="fa-solid fa-chevron-down"></i></span>
                  </a>
                </h6>
              </div>
              <div id="collapseSpecs" class="collapse">
                <div class="card-body-chat">
                  <div class="selectBox-cont">
                    <label v-for="(spec, i) in specificationsOptions" :key="i" class="custom_check w-100">
                      <input type="checkbox" v-model="selectedSpecifications" :value="spec" />
                      <span class="checkmark"></span> {{ spec }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
             <!-- المواصفات الخارجية -->
            <div class="accordion" id="accordionExternalSpecs">
              <div class="card-header-new">
                <h6 class="filter-title">
                  <a class="w-100 collapsed" data-bs-toggle="collapse" data-bs-target="#collapseExternalSpecs">
                    المواصفات الخارجية
                    <span class="float-end"><i class="fa-solid fa-chevron-down"></i></span>
                  </a>
                </h6>
              </div>
              <div id="collapseExternalSpecs" class="collapse">
                <div class="card-body-chat">
                  <div class="selectBox-cont">
                    <label v-for="(ext, i) in externalSpecificationsOptions" :key="i" class="custom_check w-100">
                      <input type="checkbox" v-model="selectedExternalSpecifications" :value="ext" />
                      <span class="checkmark"></span> {{ ext }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <!-- التقنيات الحديثة -->
            <div class="accordion" id="accordionTech">
              <div class="card-header-new">
                <h6 class="filter-title">
                  <a class="w-100 collapsed" data-bs-toggle="collapse" data-bs-target="#collapseTech">
                    التقنيات الحديثة
                    <span class="float-end"><i class="fa-solid fa-chevron-down"></i></span>
                  </a>
                </h6>
              </div>
              <div id="collapseTech" class="collapse">
                <div class="card-body-chat">
                  <div class="selectBox-cont">
                    <label v-for="(tech, i) in technicalSpecificationsOptions" :key="i" class="custom_check w-100">
                      <input type="checkbox" v-model="selectedTechnicalSpecifications" :value="tech" />
                      <span class="checkmark"></span> {{ tech }}
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <!-- توصية العملاء -->
            <div class="accordion" id="accordionMain11">
              <div class="card-header-new" id="headingSix">
                <h6 class="filter-title">
                  <a class="w-100 collapsed" data-bs-toggle="collapse" data-bs-target="#collapseSix">
                    توصية العملاء
                    <span class="float-end"><i class="fa-solid fa-chevron-down"></i></span>
                  </a>
                </h6>
              </div>
              <div id="collapseSix" class="collapse">
                <div class="card-body-chat">
                  <div class="selectBox-cont">
                    <label v-for="(rec, i) in customerRecommendations" :key="i" class="custom_check w-100">
                      <input type="checkbox" v-model="selectedRecommendations" :value="rec" />
                      <span class="checkmark"></span> {{ rec }}
                    </label>
                  </div>
                </div>
              </div>
          </div>
        </div>

      <button
        type="button"
        @click="applyFilters"
        class="d-inline-flex align-items-center justify-content-center btn w-100 btn-primary filter-btn"
      >
        <span><i class="feather-filter me-2"></i></span>تصفية النتائج
      </button>
        <a href="#" class="reset-filter" @click.prevent="resetAllFilters">إعادة ضبط الفلاتر</a>
      </form>
    </div>
  </div>
</template>
<script>
import Slider from "@vueform/slider";
import { useCarsStore } from "@/stores/cars-store";

export default {
  components: { Slider },
  data() {
    return {
      // السعر (Slider)
      // priceRange: [0, 100000],
      merge: 10,
      priceFrom: 0,
      priceTo: 100000,

      // الحالة
      carStatus: {
        جديد: "new",
        مستورد: "imported",
        مستعمل: "used",
        "جديد مستورد": "imported_new",
        ايجار: "rent",
        تقسيط: "installment",
      },
      selectedStatus: [],

      // ماركات السيارات
      carBrands: [
        "Acura","Alfa Romeo","Aston Martin","Audi","BMW","BYD","Buick",
        "Cadillac","Chrysler","Daewoo","Daihatsu","Dodge","Fiat","Ford",
        "GAC","GMC","Genesis","Honda","Hummer","Hyundai","Infiniti","Isuzu",
        "Jaguar","Jeep","Kia","Land Rover","Lexus","Lincoln","MINI","Mazda",
        "Mercedes-Benz","Mercury","Mitsubishi","Nissan","Opel","Peugeot",
        "Pontiac","Porsche","Proton","Renault","Skoda","Subaru","Suzuki",
        "Toyota","Volkswagen","Volvo","others"
      ]
      ,
      selectedBrand: "",

      // السنوات
      carYears: [
      1980, 1981, 1982, 1983, 1984, 1985, 1986, 1987, 1988, 1989,
      1990, 1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999,
      2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009,
      2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019,
      2020, 2021, 2022, 2023, 2024, 2025
    ],
      // selectedYear: "",
      yearFrom: "",
      yearTo: "",

      // بلد التصنيع
      carCountries: ["اوروبا", "امريكا", "الوكالة", "الخليج", "غير ذلك"],
      selectedCountry: "",

      // الوقود
      fuelTypes: ["بنزين", "ديزل", "كهرباء", "هايبرد"],
      selectedFuel: null,

      // ناقل الحركة (الجير)
      gearOptions: ["اوتو", "عادى", "تيبترونيك"],
      selectedGear: null,

      // المحرك (سعة CC)
      engineOptions: [
        "0-499 سي سي",
        "500-999 سي سي",
        "1000-1999 سي سي",
        "2000-2999 سي سي",
        "3000-3999 سي سي",
        "4000-4999 سي سي",
        "5000-5999 سي سي",
        "6000+ سي سي",
      ],
      selectedEngines: [],

      // لون السيارة
      carColors: [
        "أبيض", "أسود", "اسمنتى", "ازرق فاتح", "أزرق", "اخضر", "برتقالي",
        "بني", "بنفسجي", "تركواز", "بيج", "خمري", "ذهبي", "رمادي",
        "زيتى", "فضى", "كحلي"
      ],
      selectedColor: "",

      // فئات السيارات
      carCategories: ["سيدان", "SUV", "هاتشباك", "دفع رباعي", "كوبيه", "فان"],
      selectedCategories: [],

      // قديش ماشية
      mileageOptions: [
        "0-10,000 كم",
        "10,000-20,000 كم",
        "20,000-30,000 كم",
        "30,000-40,000 كم",
        "40,000-50,000 كم",
        "50,000-60,000 كم",
        "60,000-70,000 كم",
        "70,000-80,000 كم",
        "80,000-90,000 كم",
        "90,000-100,000 كم",
        "+100,000 كم",
      ],
      selectedMileage: "",

       // المواصفات
      specificationsOptions: [
        "مدخل Aux/USB", "أكياس هوائية", "تحكم كهربائى بالمقاعد", "تحكم بالمقود",
        "مقاعد بذاكرة", "زجاج كهربائى", "سنترلوك", "مقاعد مدفأة", "مشغل وسطيات",
        "مقاعد جلد", "مقاعد رياضية", "مقاعد مبردة", "مقعد كهربائى خلفى", "مقود مدفأ",
        "مكيف", "نظام انذار", "اخرى"
      ],
      selectedSpecifications: [],

     // المواصفات الخارجية
      externalSpecificationsOptions: [
        "أنوار نهارية", "اطار احتياطى", "جنوط", "حساسات امامية", "حساسات خلفية",
        "فتح بدون مفتاح", "فتحة سقف", "بانوراما", "مرايا قابلة للطى كهربائيا",
        "مصابيح زينون", "مصابيح LED", "نسخة رياضية", "كهرباء خلفى", "اخرى"
      ],
      selectedExternalSpecifications: [],

      // التقنيات الحديثة
      technicalSpecificationsOptions: [
        "Apple CarPlay", "Android Auto", "اوامر صوتية", "بروجيكتور", "بلوتوث",
        "تشغيل عن بعد", "تنبيه من التصادم الأمامى", "تنبيه النقاط العمياء",
        "تنبيه مغادرة المسار", "حساسات ضغط الاطارات", "دفلوك", "رادار",
        "شاشة لمس", "شاشة وسائط", "إغلاق تلقائي للأبواب", "كاميرا 360 درجة",
        "كاميرا خلفية", "نظام تعليق رياضى", "نظام ملاحة / خرائط", "مانع الانزلاق",
        "مثبت سرعة", "مساعد الاصطفاف", "نظام ABS", "اخرى"
      ],
      selectedTechnicalSpecifications: [],

      // التقييم
      ratingOptions: [
        { stars: 5, value: 5.0 },
        { stars: 4, value: 4.0 },
        { stars: 3, value: 3.0 },
        { stars: 2, value: 2.0 },
        { stars: 1, value: 1.0 },
      ],
      selectedRatings: [],

      // توصية العملاء
      customerRecommendations: ["٧٠٪ فأكثر", "٦٠٪ فأكثر", "٥٠٪ فأكثر", "٤٠٪ فأكثر", "٣٠٪ فأكثر"],
      selectedRecommendations: [],
    };
  },
  setup() {
    const carsStore = useCarsStore();
    return { carsStore };
  },
  methods: {
    applyFilters() {
      this.carsStore.fetchCars({
        // البحث
        search: this.search || "",

        // السعر
        // price_from: this.priceRange[0],
        // price_to: this.priceRange[1],
        price_from: this.priceFrom || "",
        price_to: this.priceTo || "",

        // الحالة
        usage_status: this.selectedStatus.join(","),

        // الماركة
        brand_name: this.selectedBrand || "",

         // السنة
        // year: this.selectedYear || "",

        // السنوات
        year_from: this.yearFrom || "",
        year_to: this.yearTo || "",

        // بلد التصنيع
        manufacturing_region: this.selectedCountry || "",

        // الوقود
        fuel_type: this.selectedFuel || "",

        // الجير
        gear: this.selectedGear || "",

        // سعة المحرك
        engine_capacity: this.selectedEngines.join(","),

        // اللون
        color: this.selectedColor || "",

        // الفئات
        model_name: this.selectedCategories.join(","),

        // قديش ماشية
        mileage: this.selectedMileage || "",

        // المواصفات
         "specifications[]": this.selectedSpecifications,

        // المواصفات الخارجية
         "external_specifications[]": this.selectedExternalSpecifications,

         // التقنيات الحديثة
         "technical_specifications[]": this.selectedTechnicalSpecifications,


        // التقييم
        ratings: this.selectedRatings.join(","),

        // توصية العملاء
        recommendations: this.selectedRecommendations.join(","),

        // عدد النتائج (من الاستور)
        pageSize: this.carsStore.filters.pageSize,
      });
    },
    resetAllFilters() {
      this.search = "";
      this.priceRange = [0, 100000];
      this.selectedStatus = [];
      this.selectedBrand = "";
      // this.selectedYear = "";
      this.selectedCountry = "";
      this.selectedFuel = null;
      this.selectedGear = null;
      this.selectedEngines = [];
      this.selectedColor = "";
      this.selectedCategories = [];
      this.selectedMileage = "";
      this.selectedRatings = [];
      this.selectedRecommendations = [];
      this.yearFrom = "";
      this.yearTo = "";
      this.priceFrom = 0;
      this.priceTo = 100000;
      this.selectedSpecifications = [];
      this.selectedExternalSpecifications= [],
      this.selectedTechnicalSpecifications= [],

      this.carsStore.resetFilters();
      this.carsStore.fetchCars();
    }
  },
};
</script>


<style>
.slider-connect {
  background: var(--slider-connect-bg, #ff9307) !important;
  cursor: pointer;
}

.slider-tooltip {
  background: var(--slider-tooltip-bg, #0b2540) !important;
  border: 1px solid var(--slider-tooltip-bg, #0b2540) !important;
  border-radius: var(--slider-tooltip-radius, 5px);
  color: var(--slider-tooltip-color, #fff);
  display: block;
  font-size: var(--slider-tooltip-font-size, 0.875rem);
  font-weight: var(--slider-tooltip-font-weight, 600);
  line-height: var(--slider-tooltip-line-height, 1.25rem);
  min-width: var(--slider-tooltip-min-width, 20px);
  padding: var(--slider-tooltip-py, 2px) var(--slider-tooltip-px, 6px);
  position: absolute;
  text-align: center;
  white-space: nowrap;
}

.roundskin .slider-tooltip {
  background: var(--slider-tooltip-bg, #ff9307) !important;
  border: 1px solid var(--slider-tooltip-bg, #ff9307) !important;
  border-radius: var(--slider-tooltip-radius, 5px);
  color: var(--slider-tooltip-color, #fff);
  display: block;
  font-size: var(--slider-tooltip-font-size, 0.875rem);
  font-weight: var(--slider-tooltip-font-weight, 600);
  line-height: var(--slider-tooltip-line-height, 1.25rem);
  min-width: var(--slider-tooltip-min-width, 20px);
  padding: var(--slider-tooltip-py, 2px) var(--slider-tooltip-px, 6px);
  position: absolute;
  text-align: center;
  white-space: nowrap;
}

.slider-handle {
  background-color: #ff9307 !important;
  border: 2px solid #ff9307 !important;
}
</style>
<style src="@vueform/slider/themes/default.css"></style>
